import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@babel/polyfill';
import { unregister } from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js